export default __webpack_public_path__ + "static/07.01-a6a287f5ffc94c9d09b521a9364d9bb5.png";